import { render } from "./Home.vue?vue&type=template&id=2b718da2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2b718da2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b718da2"]])

export default __exports__